import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

// Tinder's PopBounceButton feel: press squashes the button to 0.75, release
// springs back with a visible overshoot past 1.0 (damping 9 is deliberately
// low — if it settles without a wobble, it is wrong).
const POP_SPRING = { type: "spring", stiffness: 500, damping: 9, mass: 0.75 };

export default function ButtonIcon({ icon: Icon, label, onClick, className = "", iconClassName = "", size = 20, strokeWidth = 2.2, ...rest }) {
  return (
    <motion.button
      type="button"
      aria-label={label}
      title={label}
      onClick={onClick}
      whileTap={{ scale: 0.75 }}
      whileHover={{ scale: 1.05 }}
      transition={POP_SPRING}
      className={cn(
        "inline-flex h-11 w-11 items-center justify-center rounded-full border border-brand-line bg-white text-brand-ink shadow-ambient",
        className
      )}
      {...rest}
    >
      {Icon ? <Icon size={size} strokeWidth={strokeWidth} className={iconClassName} /> : null}
    </motion.button>
  );
}
